import { convertToFloatFormat } from '../helper';

export default {
  methods: {
    sumAllNetValues(additionalVats, firstLoad) {
      if (additionalVats.length > 0 && !firstLoad) {
        return additionalVats
          .reduce((acc, vat) => acc + parseFloat(convertToFloatFormat(vat.net.value[0])), 0)
          .toFixed(2);
      }
      return false;
    },
    sumAllVatValues(additionalVats, firstLoad) {
      if (firstLoad) return false;
      if (additionalVats.length === 0) return '0.00';
      return additionalVats
        .reduce((acc, vat) => acc + parseFloat(convertToFloatFormat(vat.vat.value[0])), 0)
        .toFixed(2);
    },
    sumGrossValue(grossValueNumbers, firstLoad) {
      if (!firstLoad) {
        return grossValueNumbers
          .reduce((acc, value) => acc + parseFloat(convertToFloatFormat(value)), 0)
          .toFixed(2);
      }
      return false;
    },
    sortAdditionalVats(additionalVats) {
      const unsortedAdditionalVats = this._.cloneDeep(additionalVats);
      // Sort by vat percentage first
      unsortedAdditionalVats.sort(
        (a, b) =>
          parseFloat(convertToFloatFormat(b.vat.percentage)) -
          parseFloat(convertToFloatFormat(a.vat.percentage))
      );
      // Sort by net value, so the largest by net are at the top
      unsortedAdditionalVats.sort(
        (a, b) =>
          parseFloat(convertToFloatFormat(b.net.value[0])) -
          parseFloat(convertToFloatFormat(a.net.value[0]))
      );
      return unsortedAdditionalVats;
    },
  },
  mounted() {
    this.$watch(
      (vm) => [vm.inputFields.net.model, vm.inputFields.vat.model].join(),
      () => {
        const summedGrossValue = this.sumGrossValue(
          [this.inputFields.net.model, this.inputFields.vat.model],
          this.firstLoad
        );
        if (summedGrossValue) {
          this.inputFields.gross.model = summedGrossValue;
        }
      }
    );
  },
};
